// Przestawianie GPSR info w kodzie

// Czekamy aż DOM się załaduje
document.addEventListener('DOMContentLoaded', function() {
    // Znajdź element do przeniesienia
    const gpsrTables = document.getElementById('gpsr-tables');
    
    // Znajdź element docelowy (po którym chcesz wstawić)
    const targetElement = document.querySelector('.product-single__tab.mt-60');
    
    // Sprawdź czy oba elementy istnieją
    if (gpsrTables && targetElement) {
        // Przenieś element bezpośrednio po elemencie docelowym
        targetElement.parentNode.insertBefore(gpsrTables, targetElement.nextSibling);
    }
});


// Dodawanie collapsa do GPSR info
document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector("#gpsr-tables");
  if (!container) return;

  const table = container.querySelector("table");
  const tbody = table?.querySelector("tbody");
  const theadRow = table?.querySelector("thead tr");

  if (!table || !tbody || !theadRow) return;

  // Ukryj tbody domyślnie
  tbody.style.display = "none";

  // Ustaw styl kursora i tła nagłówka (opcjonalnie)
  theadRow.style.cursor = "pointer";
  theadRow.style.backgroundColor = "#f0f0f0";

  // Dodaj znacznik [+] / [-]
  const th = theadRow.querySelector("th");
  if (th) {
    const toggleIcon = document.createElement("span");
    toggleIcon.textContent = " [+]";
    toggleIcon.style.color = "#007aff";
    toggleIcon.style.marginLeft = "5px";
    th.appendChild(toggleIcon);

    // Obsługa kliknięcia – toggle display
    theadRow.addEventListener("click", () => {
      const isVisible = tbody.style.display !== "none";
      tbody.style.display = isVisible ? "none" : "table-row-group";
      toggleIcon.textContent = isVisible ? " [+]" : " [-]";
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const gpsr = document.querySelector("#gpsr-tables");
  if (gpsr) {
    gpsr.style.borderRadius = "5px";
    gpsr.style.backgroundColor = "#eeeeee";

    gpsr.style.maxWidth = "1470px";
    gpsr.style.marginLeft = "auto";
    gpsr.style.marginRight = "auto";


    const table = gpsr.querySelector("table");
    if (table) {
      table.style.border = "none";
      table.style.borderCollapse = "collapse";
      table.style.width = "100%"; // Upewniamy się że tabela się rozciąga
      table.style.overflow = "hidden";

      const cells = table.querySelectorAll("td, th");
      cells.forEach(cell => {
        cell.style.border = "none";
        cell.style.padding = "8px";
        cell.style.color = "#333";
      });

      const thead = table.querySelector("thead");
      if (thead) {
        const rows = thead.querySelectorAll("tr");
        const firstRow = rows[0];
        const lastRow = rows[rows.length - 1];

        // Stylizacja wszystkich th
        thead.querySelectorAll("th").forEach(th => {
          th.style.backgroundColor = "#eeeeee";
          th.style.color = "#333";
          th.style.fontWeight = "bold";
          th.style.padding = "10px";
  

          // 👇 Zmieniamy kolor elementów wewnątrz th (np. niebieski +)
          const inner = th.querySelectorAll("*");
          inner.forEach(el => {
            el.style.color = "#333";
            el.style.fill = "#333"; // jeśli to SVG
          });
        });

        if (firstRow) {
          const ths = firstRow.querySelectorAll("th");
          if (ths.length > 0) {
            ths[0].style.borderTopLeftRadius = "5px";
            ths[ths.length - 1].style.borderTopRightRadius = "5px";
          }
        }

        if (lastRow) {
          const ths = lastRow.querySelectorAll("th");
          if (ths.length > 0) {
            ths[0].style.borderBottomLeftRadius = "5px";
            ths[ths.length - 1].style.borderBottomRightRadius = "5px";
          }
        }
      }

      const tbody = table.querySelector("tbody");
      if (tbody) {
        const rows = tbody.querySelectorAll("tr");
        rows.forEach(row => {
          const tds = row.querySelectorAll("td");
          if (tds.length === 2) {
            tds[0].style.width = "30%"; // ✅ SZERSZA LEWA KOLUMNA
            tds[1].style.width = "70%"; // ✅ WĘŻSZA PRAWA
            tds[0].style.wordBreak = "keep-all"; // zapobiega łamaniu słów
            tds[0].style.whiteSpace = "normal"; // pozwala na łamanie linii tylko między słowami
            tds[0].style.paddingLeft = "20px";
          }
        });

        if (rows.length > 0) {
          const lastRow = rows[rows.length - 1];
          const tds = lastRow.querySelectorAll("td");
          if (tds.length > 0) {
            tds[0].style.borderBottomLeftRadius = "5px";
            tds[tds.length - 1].style.borderBottomRightRadius = "5px";
          }
        }
      }
    }
  }
});



// Dodawanie collapsa do 'additional'

document.addEventListener("DOMContentLoaded", () => {
  const targetContainer = document.querySelector("#proTabs1");
  if (!targetContainer) return;

  const nodes = Array.from(targetContainer.childNodes);
  let inAdditionalBlock = false;
  let startNode = null;
  let endNode = null;
  let betweenNodes = [];

  for (let i = 0; i < nodes.length; i++) {
    const node = nodes[i];

    // Szukamy [additional]
    if (node.nodeType === 3 && node.textContent.includes("[additional]")) {
      inAdditionalBlock = true;
      startNode = node;

    } else if (node.nodeType === 3 && node.textContent.includes("[/additional]")) {
      endNode = node;
      inAdditionalBlock = false;

      // Teraz mamy pełny blok, robimy toggle:
      const wrapper = document.createElement("div");
      wrapper.style.display = "none";

      // Przenieś międzyznacznikowe elementy do wrappera
      betweenNodes.forEach(n => wrapper.appendChild(n));

      // Wstaw wrappera zaraz po znaczniku otwierającym
      targetContainer.insertBefore(wrapper, endNode);

      // Tworzymy nagłówek toggle
      const toggle = document.createElement("div");
      toggle.textContent = "FAQ [+]";
      toggle.style.cursor = "pointer";
      toggle.style.fontWeight = "bold";
      toggle.style.margin = "18px 0";
      toggle.style.padding = "10px";
      toggle.style.backgroundColor = "#eee";
      toggle.style.borderRadius = "5px";

      targetContainer.insertBefore(toggle, startNode);

      toggle.addEventListener("click", () => {
        const isVisible = wrapper.style.display === "block";
        wrapper.style.display = isVisible ? "none" : "block";
        toggle.textContent = isVisible ? "FAQ [+]" : "FAQ [-]";
      });

      // Usuń znaczniki [additional] i [/additional]
      startNode.textContent = startNode.textContent.replace("[additional]", "");
      endNode.textContent = endNode.textContent.replace("[/additional]", "");

      // Resetuj
      betweenNodes = [];
      startNode = null;
      endNode = null;

    } else if (inAdditionalBlock) {
      // Przechowujemy elementy między znacznikami
      betweenNodes.push(node);
    }
  }
});



// korekta ceny w 'recently viewed'
function formatRecentlyViewedPrices() {
  document.querySelectorAll('.recently-viewed .money').forEach(function(el) {
    let text = el.textContent.trim();

    // Pomijamy już przerobione elementy
    if (text.includes('zł')) return;

    // Usuwamy symbol dolara i spacje
    let value = text.replace('$', '').trim();

    // Usuwamy przecinki z zapisu angielskiego tysięcy (np. 1,855.00 → 1855.00)
    value = value.replace(/,/g, '');

    // Zamieniamy kropkę dziesiętną na przecinek
    value = value.replace('.', ',');

    // Dodajemy " zł" na końcu
    el.textContent = value + ' zł';
  });
}

document.addEventListener("DOMContentLoaded", function () {
  formatRecentlyViewedPrices();

  // Obserwator nasłuchujący na zmiany w sekcji recently-viewed
  const target = document.querySelector('.recently-viewed');
  if (target) {
    const observer = new MutationObserver(() => {
      formatRecentlyViewedPrices();
    });
    observer.observe(target, { childList: true, subtree: true });
  }
});

// korekta ceny w 'recently viewed'
function formatRecentlyViewedPrices() {
  document.querySelectorAll('#recently-viewed-products .money').forEach(function(el) {
    let text = el.textContent.trim();

    // Pomijamy już przerobione elementy
    if (text.includes('zł')) return;

    // Usuwamy symbol dolara i spacje
    let value = text.replace('$', '').trim();

    // Usuwamy przecinki z zapisu angielskiego tysięcy (np. 1,855.00 → 1855.00)
    value = value.replace(/,/g, '');

    // Zamieniamy kropkę dziesiętną na przecinek
    value = value.replace('.', ',');

    // Dodajemy " zł" na końcu
    el.textContent = value + ' zł';
  });
}

document.addEventListener("DOMContentLoaded", function () {
  formatRecentlyViewedPrices();

  // Obserwator nasłuchujący na zmiany w sekcji recently-viewed
  const target = document.querySelector('#recently-viewed-products');
  if (target) {
    const observer = new MutationObserver(() => {
      formatRecentlyViewedPrices();
    });
    observer.observe(target, { childList: true, subtree: true });
  }
});

document.addEventListener("DOMContentLoaded", function() {
  // pobieramy oba elementy
  const topCenter = document.querySelector(".site-header_top_center");
  const headerTop = document.querySelector(".header-top");

  if (topCenter && headerTop) {
    // przenosimy .site-header_top_center zaraz pod .header-top
    headerTop.insertAdjacentElement("afterend", topCenter);
  }
});


document.addEventListener("DOMContentLoaded", function() {
  const left = document.querySelector(".site-header_top_left");
  const center = document.querySelector(".site-header_top_right");
  const right = document.querySelector(".content-header-center-right");
  const row = document.querySelector(".header-top .container .row");

  if (left && center && right && row) {
    // Czyścimy row
    row.innerHTML = "";

    // Tworzymy 3 wrappery
    const leftCol = document.createElement("div");
    const centerCol = document.createElement("div");
    const rightCol = document.createElement("div");

    leftCol.classList.add("header-col", "header-col-left");
    centerCol.classList.add("header-col", "header-col-center");
    rightCol.classList.add("header-col", "header-col-right");

    // Wrzucamy elementy
    leftCol.appendChild(left);
    centerCol.appendChild(center);
    rightCol.appendChild(right);

    // Dodajemy do .row
    row.appendChild(leftCol);
    row.appendChild(centerCol);
    row.appendChild(rightCol);

    // Ustawiamy flex na row
    row.style.display = "flex";
    row.style.alignItems = "center";
    row.style.width = "100%";
  }
});
/*
document.addEventListener("DOMContentLoaded", function () {
  const elements = document.querySelectorAll("*");

  elements.forEach(el => {
    if (el.childNodes.length > 0) {
      el.childNodes.forEach(node => {
        if (node.nodeType === Node.TEXT_NODE) {
          if (node.textContent.includes("Michał Drąg")) {
            node.textContent = node.textContent.replace(/Michał Drąg/g, "Michał Srichał");
          }
        }
      });
    }
  });
});
*/

jQuery(document).ready(function($) {
  setTimeout(function() {
    var filterContents = $('.gf-filter-contents.gf-grid--4-col').first();
    var globoWrapper = $('.globo-selected-items-wrapper').first();
    
    // Sprawdź czy element nie jest już przed filterContents
    if (globoWrapper.length && filterContents.length) {
      var prevElement = filterContents.prev();
      
      // Jeśli poprzedni element nie jest globo-wrapper, przenieś
      if (!prevElement.hasClass('globo-selected-items-wrapper')) {
        globoWrapper.detach().insertBefore(filterContents);
        console.log('Element przeniesiony');
        
        // Usuń ewentualne duplikaty
        $('.globo-selected-items-wrapper').slice(1).remove();
      } else {
        console.log('Element już jest w odpowiednim miejscu');
      }
    }
  }, 2000);
});



$(function(){
  const cls = 'shopify-click-label-1';

  function addLabel(){
    // szukamy tylko w #gf-tree, żeby nie duplikować w controls-container
    $("#gf-tree .gf-filter-trigger").each(function(){
      if($(this).next("." + cls).length === 0){
        $(this).after(
          $('<span>')
            .addClass(cls)
            .text(' Kliknij przycisk i wyszukaj produkty pasujące do Twojego samochodu')
            .css({
              display:'inline-block',
              marginLeft:'25px',
              fontSize:'15px',
              lineHeight:'40px',
              whiteSpace:'nowrap'
            })
        );
      }
    });
  }

  // wywołanie na starcie
  addLabel();

  // obserwujemy zmiany w DOM – działa gdy Shopify doładuje filtry
  const observer = new MutationObserver(addLabel);
  observer.observe(document.body, { childList: true, subtree: true });
});




(() => {
  // CSS
  const css = `
    .gf-filter-contents-inner { position: relative; }
    /* ukrycie okienka po kliknięciu 'ok' */
    .gf-filter-contents-inner.gf-hidden-by-ok { display: none !important; }
    /* wygląd przycisku */
    .gf-ok-close {
      position: absolute;
      right: 20px;
      bottom: 20px;
      padding: 5px 15px;
      border: 1px solid #a8a8a8;
      border-radius: 6px;
      background: #ffd200;
      color: #333;
      box-shadow: 4px 4px 10px 1px rgba(132, 132, 132, 0.3);
      cursor: pointer;
      z-index: 9999;
      font-weight: 500;
      font-size: 15px;
      font-family:Bai Jamjuree;

    }
    .gf-ok-close:hover {  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0,0,0,0.2); }
  `;
  const style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  // Dodawanie przycisku do każdego okienka (również dynamicznie dodawanych)
  function addOkButtons() {
    document.querySelectorAll('.gf-filter-contents-inner').forEach(container => {
      if (container.querySelector('.gf-ok-close')) return;
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'gf-ok-close';
      btn.textContent = 'Zatwierdź';
      container.appendChild(btn);
    });
  }
  addOkButtons();
  new MutationObserver(addOkButtons)
    .observe(document.documentElement, { childList: true, subtree: true });

  // Delegacja zdarzeń:
  document.addEventListener('click', function(e){
    // 1) klik w 'ok' -> ukryj okienko
    const okBtn = e.target.closest('.gf-ok-close');
    if (okBtn) {
      e.preventDefault(); e.stopPropagation();
      const inner = okBtn.closest('.gf-filter-contents-inner');
      if (inner) {
        inner.classList.add('gf-hidden-by-ok');
        // opcjonalnie: zdejmij klasy "open" z kontenera (jeśli jakieś są)
        const host = inner.closest('.gf-filter-contents');
        if (host) host.classList.remove('is-open','open','active','expanded','show');
      }
      return;
    }

    // 2) klik w trigger filtra -> pokaż z powrotem (gdy był ukryty przez 'ok')
    const trigger = e.target.closest('.gf-filter-trigger');
    if (trigger) {
      const block = trigger.closest('.gf-filter-contents') || trigger.parentElement;
      const inner = block && block.querySelector('.gf-filter-contents-inner');
      if (inner) inner.classList.remove('gf-hidden-by-ok');
    }
  });
})();


jQuery(function($){
  const COLOR = '#000000';

  function apply(){
    $('.clear-refinements, .clear-refinements a').each(function(){
      this.style.setProperty('color', COLOR, 'important');
    });
  }

  apply();

  // Reaplikacja gdy wtyczka zmienia DOM
  const mo = new MutationObserver(apply);
  mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class','style'] });

  // Dodatkowo po klikach (bywa, że UI się przebudowuje na eventy)
  $(document).on('click change', '.clear-refinements, [class*="globo"], [id*="globo"]', () => {
    setTimeout(apply, 0);
  });
});



$(document).ready(function() {
    // Znajdź kontener i nagłówek h1 z tytułem produktu
    const $container = $('.container');
    const $productTitle = $('.product-single__title');
    
    if ($container.length && $productTitle.length) {
        // Pobierz tekst z nagłówka h1
        const titleText = $productTitle.text().trim();
        
        // Utwórz nowy element h2
        const $h2Element = $('<h2>', {
            'class': 'product-info-header',
            'text': 'Informacje o produkcie ' + titleText
        });
        
        // Znajdź element nav-tabs
        const $navTabs = $container.find('.nav-tabs');
        
        if ($navTabs.length) {
            // Wstaw h2 przed nav-tabs
            $h2Element.insertBefore($navTabs);
        } else {
            // Jeśli nav-tabs nie istnieje, dodaj na początku kontenera
            $container.prepend($h2Element);
        }
    }
});

$(document).ready(function() {
    // Znajdź wszystkie elementy <p> z atrybutem itemprop="sku"
    $('p[itemprop="sku"]').each(function() {
        var $pElement = $(this);
        
        // Znajdź odpowiedni span z klasą label-sku w tym samym kontenerze
        var $labelSku = $pElement.find('.label-sku').first();
        
        // Jeśli nie znaleziono w tym elemencie, szukaj w rodzicu
        if ($labelSku.length === 0) {
            $labelSku = $pElement.closest('.product-single_info-item').find('.label-sku').first();
        }
        
        // Jeśli znaleziono element span z klasą label-sku
        if ($labelSku.length > 0) {
            // Przenieś atrybut itemprop="sku"
            $labelSku.attr('itemprop', 'sku');
            
            // Usuń atrybut z elementu <p>
            $pElement.removeAttr('itemprop');
            
            console.log('Przeniesiono itemprop="sku" do elementu:', $labelSku[0]);
        }
    });
});


$(document).ready(function() {
    // Znajdź wszystkie elementy <p> z atrybutem itemprop="brand"
    $('p[itemprop="brand"]').each(function() {
        var $pElement = $(this);
        
        // Pobierz zawartość tekstową elementu <p> (pomijając HTML dzieci)
        var textContent = $pElement.contents().filter(function() {
            return this.nodeType === 3; // Node.TEXT_NODE
        }).text().trim();
        
        // Jeśli znaleziono tekst (np. "309411")
        if (textContent) {
            // Utwórz nowy span z atrybutem itemprop="brand"
            var $newSpan = $('<span itemprop="brand"></span>').text(textContent);
            
            // Usuń tekst z elementu <p> (zachowaj inne elementy HTML)
            $pElement.contents().filter(function() {
                return this.nodeType === 3;
            }).remove();
            
            // Dodaj nowy span na końcu elementu <p>
            $pElement.append($newSpan);
            
            // Usuń atrybut itemprop z elementu <p>
            $pElement.removeAttr('itemprop');
            
            console.log('Przeniesiono itemprop="brand" do nowego span z wartością:', textContent);
        }
    });
});


document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.block_social .list-inline-item a').forEach(a => {
    const rels = (a.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
    if (!rels.includes('nofollow')) rels.push('nofollow');
    a.setAttribute('rel', rels.join(' '));
  });
});



(function($){
  function formatPriceString(raw){
    if(!raw || typeof raw !== 'string') return raw;
    raw = raw.trim().replace(/\u00A0/g, ' ').replace(/\s+/g,' ');
    const m = raw.match(/-?\d[\d\.,\s\u00A0]*/);
    if(!m) return raw;
    let numeric = m[0].replace(/[\s\u00A0]/g,'');
    const hasComma = numeric.indexOf(',') !== -1;
    const hasDot   = numeric.indexOf('.') !== -1;

    if(hasComma && hasDot){
      numeric = numeric.replace(/,/g,'').replace('.',',');
    } else if(hasDot && !hasComma){
      const parts = numeric.split('.');
      const last = parts[parts.length-1];
      if(last.length === 2){
        numeric = parts.slice(0,-1).join('') + ',' + last;
      } else {
        numeric = numeric.replace(/\./g,'');
      }
    } else if(hasComma && !hasDot){
      const parts = numeric.split(',');
      const last = parts[parts.length-1];
      if(last.length === 2){
        if(parts.length > 2){
          const lastPart = parts.pop();
          numeric = parts.join('') + ',' + lastPart;
        }
      } else {
        numeric = numeric.replace(/,/g,'');
      }
    }

    const before = raw.slice(0, m.index).trim();
    const after  = raw.slice(m.index + m[0].length).trim();
    return (before ? before + ' ' : '') + numeric + (after ? ' ' + after : '');
  }

  function fixPriceElement($el){
    let replaced = false;
    $el.contents().filter(function(){ return this.nodeType === 3 && this.textContent.trim(); })
      .each(function(){ this.textContent = formatPriceString(this.textContent); replaced = true; });
    if(!replaced) $el.text(formatPriceString($el.text()));
  }

  function fixAll(){
    $('.spf-product-card__price.money, .product-price__price, .subtotal, .product-price,').each(function(){ 
      fixPriceElement($(this)); 
    });
  }

  $(fixAll);

  const observer = new MutationObserver(function(muts){
    muts.forEach(function(m){
      if(m.addedNodes && m.addedNodes.length){
        m.addedNodes.forEach(function(node){
          if(node.nodeType !== 1) return;
          const $node = $(node);
          if($node.is('.spf-product-card__price.money, .product-price__price, .subtotal, .product-price')) {
            fixPriceElement($node);
          } else {
            $node.find('.spf-product-card__price.money, .product-price__price, .subtotal, .product-price')
                 .each(function(){ fixPriceElement($(this)); });
          }
        });
      }
    });
  });

  (function start(){
    const target = document.body || document.documentElement;
    if(!target) { setTimeout(start,50); return; }
    observer.observe(target, { childList:true, subtree:true, characterData:true });
  })();

})(jQuery);




(function($){
  function formatPriceString(raw){
    if(!raw || typeof raw !== 'string') return raw;
    raw = raw.trim().replace(/\u00A0/g, ' ').replace(/\s+/g,' ');
    const m = raw.match(/-?\d[\d\.,\s\u00A0]*/);
    if(!m) return raw;
    let numeric = m[0].replace(/[\s\u00A0]/g,'');
    const hasComma = numeric.indexOf(',') !== -1;
    const hasDot   = numeric.indexOf('.') !== -1;

    if(hasComma && hasDot){
      numeric = numeric.replace(/,/g,'').replace('.',',');
    } else if(hasDot && !hasComma){
      const parts = numeric.split('.');
      const last = parts[parts.length-1];
      if(last.length === 2){
        numeric = parts.slice(0,-1).join('') + ',' + last;
      } else {
        numeric = numeric.replace(/\./g,'');
      }
    } else if(hasComma && !hasDot){
      const parts = numeric.split(',');
      const last = parts[parts.length-1];
      if(last.length === 2){
        if(parts.length > 2){
          const lastPart = parts.pop();
          numeric = parts.join('') + ',' + lastPart;
        }
      } else {
        numeric = numeric.replace(/,/g,'');
      }
    }

    const before = raw.slice(0, m.index).trim();
    const after  = raw.slice(m.index + m[0].length).trim();
    return (before ? before + ' ' : '') + numeric + (after ? ' ' + after : '');
  }

  function fixPriceElement($el){
    let txt = $el.text().trim();
    let formatted = formatPriceString(txt);
    if(txt !== formatted){
      $el.text(formatted);
    }
  }

  function observeSubtotal(el){
    const $el = $(el);
    fixPriceElement($el); // popraw od razu

    const observer = new MutationObserver(function(){
      fixPriceElement($el);
    });

    observer.observe(el, { childList: true, characterData: true, subtree: true });
  }

  $(document).ready(function(){
    $('.product-subtotal, .cart__subtotal').each(function(){
      observeSubtotal(this);
    });
  });
})(jQuery);



(function($) {
  // Funkcja, która zmienia tekst
  function updateCartHeadingText($el) {
    let originalText = $el.text();

    // Sprawdza, czy tekst zawiera frazy do zamiany
    if (originalText.includes('There are') && originalText.includes('items in your cart')) {
      let updatedText = originalText
        .replace('There are', 'W koszyku jest')
        .replace('items in your cart', 'produktów');
      
      // Zmienia tekst tylko wtedy, gdy zaszła zmiana
      if (originalText !== updatedText) {
        $el.text(updatedText);
      }
    }
  }

  // Funkcja obserwatora
  function observeCartHeading(el) {
    const $el = $(el);
    updateCartHeadingText($el); // Popraw od razu

    const observer = new MutationObserver(function() {
      updateCartHeadingText($el);
    });

    // Obserwuje zmiany w treści elementu
    observer.observe(el, { childList: true, characterData: true, subtree: true });
  }

  // Uruchamia skrypt po załadowaniu dokumentu
  $(document).ready(function() {
    // Używamy .each() tak samo jak w Twoim skrypcie
    $('.cart__heading span').each(function() {
      observeCartHeading(this);
    });
  });
})(jQuery);


document.addEventListener("DOMContentLoaded", function () {
    function setAltTags() {
        // pobranie tytułu produktu
        var productTitle = document.querySelector(".product-single__title");
        if (!productTitle) return;

        var titleText = productTitle.textContent.trim();

        // ustaw alt dla wszystkich obrazów w klasie .w-100
        document.querySelectorAll(".w-100 img").forEach(function(img){
            img.setAttribute("alt", titleText);
        });

        // ustaw alt dla wszystkich obrazów w klasie .product-single__thumbnail-image
        document.querySelectorAll(".product-single__thumbnail-image").forEach(function(img){
            img.setAttribute("alt", titleText);
        });
    }

    // odpali raz po załadowaniu
    setAltTags();

    // MutationObserver dla dynamicznych zmian (np. ajax, slider)
    var observer = new MutationObserver(setAltTags);
    observer.observe(document.body, { childList: true, subtree: true });
});





function formatPriceEU(el) {
  let text = el.textContent;

  // znajdź liczbę
  let match = text.match(/(\d{1,3}(,\d{3})*(\.\d{2}))/);
  if (!match) return;

  let number = match[0];

  // usuń przecinki (tysiące)
  number = number.replace(/,/g, '');

  // zamień . na ,
  number = number.replace('.', ',');

  el.textContent = text.replace(match[0], number);
}

function fixAllPrices() {
  document.querySelectorAll('.ymq-b2b-price-hidden').forEach(el => {
    formatPriceEU(el);
  });
}

// 🔁 odpal kilka razy (bo appki lubią się ładować z opóźnieniem)
let tries = 0;
let interval = setInterval(() => {
  fixAllPrices();
  tries++;

  if (tries > 20) clearInterval(interval); // po ~10s kończymy
}, 500);

// 👀 obserwator DOM (na przyszłe zmiany)
const observer = new MutationObserver((mutations) => {
  mutations.forEach(mutation => {
    mutation.addedNodes.forEach(node => {
      if (node.nodeType === 1) {
        if (node.matches?.('.ymq-b2b-price-hidden')) {
          formatPriceEU(node);
        }
        node.querySelectorAll?.('.ymq-b2b-price-hidden').forEach(formatPriceEU);
      }
    });
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});



